import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import Plyr from 'plyr-react';

import Details from './Details';

const VideoPlayer = forwardRef(({ item }: { item: Record<string, any> }, ref: any) => {
  const plyrRef = useRef<any>();
  useImperativeHandle(ref, () => ({
    play: () => setTimeout(plyrRef.current?.plyr?.play, 0)
  }))

  return (
    <div className="p-video-player">
      <Plyr
        ref={plyrRef as any}
        source={{
          type: 'video',
          sources: [
            {
              src: item.media_url,
            },
          ],
          poster: item.image,
        }}
      />
      <Details body item={item} />
    </div>
  )
})

export default VideoPlayer;
